module.exports = __webpack_public_path__ + "9a12732727e03fce18f280c256dc82e8.jpg";